import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ServiceDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => Promise<void>;
  onHideInstead?: () => Promise<void>;
  isDeleting: boolean;
}

export const ServiceDeleteDialog = ({
  open,
  onOpenChange,
  onDelete,
  onHideInstead,
  isDeleting
}: ServiceDeleteDialogProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-white border border-gray-200">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-yellow-600" />
            {t('services.deleteConfirmTitle')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            <p className="mb-3">
              {t('services.deleteConfirmDescription')}
            </p>
            <div className="bg-yellow-50 p-3 rounded-md border border-yellow-200 mb-2">
              <p className="font-medium text-yellow-800 mb-1">{t('services.deleteConsiderHiding')}</p>
              <p className="text-yellow-700 text-sm">
                {t('services.deleteConsiderHidingDescription')}
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
          {onHideInstead && (
            <AlertDialogAction 
              onClick={onHideInstead}
              className="bg-yellow-600 hover:bg-yellow-700 text-white"
            >
              {t('services.hideInstead')}
            </AlertDialogAction>
          )}
          <AlertDialogAction 
            onClick={onDelete}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {isDeleting ? t('common.deleting') : t('common.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
